export default __webpack_public_path__ + "static/thank-you-graphic-50f6061af6e9346b8c7b8e08a6557e52.png";